<template>
  <span>
    <span v-html="buttonb || show_all ? showString : showString + '...'"></span>
    <span @click="runS()">
      <b v-if="descBool" style="color: green">
        <i v-if="!buttonb" class="fa fa-plus"></i>
        <i v-else class="fa fa-minus"></i>
      </b>
    </span>
  </span>
</template>

<script>
export default {
  props: ["objStringg", "show_all", "descBool"],
  data() {
    return {
      buttonb: false,
      stringg: "",
      showString: "",
      value: 20,
    };
  },
  watch: {
    show_all(newQuestion, oldQuestion) {
      if (newQuestion) this.allSize();
      else this.forReduce(this.value);
    },
  },
  methods: {
    runS() {
      if (!this.buttonb) this.allSize();
      else this.reduce();
      this.buttonb = !this.buttonb;
    },
    allSize() {
      this.forReduce(this.stringg.length);
    },
    reduce() {
      this.forReduce(this.value);
    },
    forReduce(sizeF) {
      if (!this.objStringg) return " ";
      var newString = "";
      this.stringg = JSON.stringify(this.objStringg);
      for (var i = 0; i < sizeF; i++)
        if (
          this.stringg[i] !== undefined &&
          this.stringg[i] !== null &&
          this.stringg[i] !== "undefined" &&
          this.stringg[i] !== "null"
        )
          newString += this.stringg[i];
      this.showString = newString;
    },
  },
  beforeMount() {
    this.reduce();
  },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Orders_v2/Aggregates/ReduceText.vue